import * as React from 'react';
import classNames from 'classnames';
import styles from './Search.scss';
import { t } from '~/helpers/localization';
import { ICategories } from '~/interfaces';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { search, resetSearch } from '~/Actions/ActionCategory';
import { resetFilters } from '~/Actions/ActionFilter';
import { playButtonClickSound, playInputSound } from '~/helpers/audioApi';
import { State } from '~/Reducers';

interface IProps {
    onKeyDown?: any;
    resetSearch?: any;
    category: ICategories;
}

const stateSelector = (state: State) => {
    return {
        search: state.ReducerCategory.search,
        filteredItems: state.ReducerFilter.filteredItems,
    };
};

const Search = (props: IProps) => {
    const appState = useSelector<State, ReturnType<typeof stateSelector>>(stateSelector, shallowEqual);
    const dispatch = useDispatch();
    const [state, setState] = React.useState<{
        value: string;
        isVisibleResetSearch: boolean;
    }>({
        value: '',
        isVisibleResetSearch: false,
    });

    const onChange = (event: React.KeyboardEvent) => {
        const target = event.target as HTMLInputElement;
        const value = target.value;
        const isVisibleResetSearch = !!value.length;

        setState({ value, isVisibleResetSearch });
    };

    const onKeyUp = (event: React.KeyboardEvent) => {
        const target = event.target as HTMLInputElement;
        dispatch(resetFilters(props.category));
        dispatch(search(target.value, props.category));
        props.onKeyDown?.(target.value, event);
    };

    const onKeyDown = (event: React.KeyboardEvent) => {
        if (event.key !== 'Unidentified') {
            playInputSound();
        }
    };

    const _resetSearch = () => {
        playButtonClickSound();

        setState({ value: '', isVisibleResetSearch: false });
        dispatch(resetSearch());
        props.resetSearch?.();
    };

    React.useEffect(() => {
        if (!appState.search?.results?.length && state.value.length && !!appState.filteredItems?.length) {
            setState({ value: '', isVisibleResetSearch: false });
        }
    }, [appState.filteredItems, appState.search]);

    const classNameSearchWrap = classNames(styles.searchWrap);

    return (
        <div className={classNameSearchWrap}>
            <div className={styles.searchInputWrap}>
                {state.isVisibleResetSearch && <span className={styles.resetSearch} onClick={_resetSearch.bind(this)} />}
                <input
                    value={state.value}
                    placeholder={t('Поиск по названию')}
                    type="text"
                    className={styles.searchInput}
                    onKeyUp={onKeyUp.bind(this)}
                    onKeyDown={onKeyDown.bind(this)}
                    onChange={onChange.bind(this)}
                />
            </div>
        </div>
    );
};

export default Search;
